var option_default = {
  "option": "c-1kk",
  "user_choice": "_5Of8Q",
  "check": "_4XQhE",
  "image": "b4N7j",
  "input": "nqiMu",
  "title": "vZ0Cc",
  "centered": "Mqxep",
  "with_result": "PTl34",
  "list": "hkZCL",
  "with_image": "EeBW3",
  "progress": "W7hhl",
  "progress_value": "_70beK",
  "label": "jehyy",
  "cta": "MDubC",
  "adornment_icon": "NCQ69",
  "remove": "Xq2lX",
  "removeButton": "OzPbt",
  "removeButtonIcon": "z0FuY",
  "overlay": "_7R-yg",
  "shown": "oF-S-",
  "dark": "uYdFN",
  "spinner": "g31Iq",
  "spin": "_6zYOG"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
